import forEach from '../../../../javascripts/dom/forEach';
import addClass from '../../../../javascripts/dom/addClass';
import removeClass from '../../../../javascripts/dom/removeClass';

const galleries = document.querySelectorAll('[data-js-module="o-lightbox-gallery"]');
const inViewportClass = 'o-lightbox-gallery--is-in-viewport';

const init = async () => {
  forEach(galleries, (index, element) => {
    new window.Waypoint({
      element,
      handler: direction => {
        if (direction === 'down') {
          addClass(element, inViewportClass);
        } else {
          removeClass(element, inViewportClass);
        }
      },
      offset: () => window.Waypoint.viewportHeight() - 100
    });
  });
};

if (galleries.length) init();
